module.exports = __webpack_public_path__ + "img/news_ads_mobile_2.8cf4f0ae.png";